import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IScrapeReportPayload {
    assignedId: string
    relatedRecordId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const scrapeReportSlice = createSlice({
    name: 'reporting/scrape-report',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IScrapeReportPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const scrapeReportActions = scrapeReportSlice.actions
export default scrapeReportSlice.reducer
